<template>
    <b-card class="card-summary"  bg-variant="dark" text-variant="white" title="Summary">
        <div class="tablist" role="tablist">
            <b-card no-body class="mb-1" v-for="(item, key) in finalEvents" :key="key">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-btn block href="#" v-b-toggle="'summary_day_' + item.day" variant="info">{{ strings.day }} #{{ item.day }}</b-btn>
                </b-card-header>
                <b-collapse :id="'summary_day_' + item.day" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <p class="card-text">
                            <ul class="event-summary-list">
                                <li class="event-summary-item" v-for="value in item.chosenItemText" :key="value">
                                {{ value }}
                                </li>
                            </ul>
                        </p>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
        <p class="card-text">
            <div style="text-align: center;">
                <button type="button" href="" class="button button--success button--full input-width--15"
                :disabled="isButtonDisabled" :class="{'button--disabled':isButtonDisabled}"
                @click.prevent="goToCheckout()"
                >{{ strings.continue }}</button>
                <p class="form__note form__note--subtle text-white" v-show="isButtonDisabled">(Select the room and/or package for all the days before continuing)</p>
            </div>
        </p>
        <!--<p class="card-text">
            <ul>
                <li 
                v-for="(item, key) in finalEvents" 
                :key="key">
                {{ strings.day }} #{{ item.day }}: {{ item.chosenItemText }}
                </li>
            </ul>
            <div style="text-align: center;">
                <button type="button" href="" class="button button--success button--full input-width--15"
                :disabled="isButtonDisabled" :class="{'button--disabled':isButtonDisabled}"
                @click.prevent="goToOperaCheckout()"
                >{{ strings.continue }}</button>
                <p class="form__note form__note--subtle text-white" v-show="isButtonDisabled">(Select the room and/or package for all the days before continuing)</p>
            </div>
        </p>-->
    </b-card>
</template>

<script>
export default {
    data () {
        return {
            text: `
        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
        richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
        brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
        tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
        assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
        wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
        vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
        synth nesciunt you probably haven't heard of them accusamus labore VHS.
      `
 
        }
    },
    methods: {
        goToCheckout(){
            if(this.useNewCheckoutPage){
                this.$store.dispatch('goToCheckout', {});
            } else {
                this.$store.dispatch('goToOperaCheckout', {});
            }
        },
    },
    computed: {
        useNewCheckoutPage() {
            return this.$store.state.useNewCheckoutPage;
        },
        finalEvents(){
            return this.$store.state.finalEvents;
        },
        strings(){
            return this.$store.state.strings;
        },
        isButtonDisabled(){
            return this.$store.state.finalEvents.length < this.$store.state.eventList.length;
        }
    }
}
</script>

<style scoped>
    .card-title {
        margin-bottom: .75rem;
        font-size: 1.5rem;
        border: none;
        color: #fff!important;
    }
    .text-white {
        color: #fff!important;
    }

    .bg-dark {
        background-color: #6c757d!important;
    }

    .card-summary {
        margin-bottom: 20px;
    }

    .input-width--15 {
        width: 15% !important;
    }

    .p-1 {
        padding: .25rem!important;
    }

    .p-1 a {
        display: block;
        color: white;
        background: #6c757d!important;
        width: 100%;
        padding: .375rem .75rem;
        text-align: center;
        text-decoration: none;
        outline: none;
    }

    .p-1 a:hover {
        text-decoration: none;
    }

    .event-summary-item {
        color:  #505050;
    }

    .btn {
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }

    .button {
        margin-bottom: 0;
        margin-top: 20px;
        cursor: pointer;
    }

    .tablist {
        width: 80%;
        margin-right: auto;
        margin-left: auto;
    }

</style>
